import 'css-chunksrc/client/scenes/moveElement/projectsSelection/section/styles.scss';export default {
  "header": "_header_v2req_1",
  "iconBox": "_iconBox_v2req_10",
  "icon": "_icon_v2req_10",
  "open": "_open_v2req_28"
};